import { render, staticRenderFns } from "./sk-radio-img.vue?vue&type=template&id=b66aecfe&scoped=true&"
import script from "./sk-radio-img.vue?vue&type=script&lang=js&"
export * from "./sk-radio-img.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio-img.vue?vue&type=style&index=0&id=b66aecfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66aecfe",
  null
  
)

export default component.exports